// extracted by mini-css-extract-plugin
export default {"Main":"Phonemodel_Main__MRY7d"};